import { type ReactElement } from 'react';

import { ChipFilter, Focusable } from '@spotify-internal/encore-web';
import { Tooltip, TooltipRoot } from '@spotify-internal/encore-web/next';

import { type FilterMeta } from './provider';

export const ToggleFilterChip = ({
  filter,
  value,
  onRemove,
  'data-track-id': trackingId = 'checkbox.toggle-filter-chip',
  'data-track-data-active': trackedActive,
}: {
  filter: FilterMeta;
  value: boolean;
  onRemove: () => void;
  'data-track-id'?: string;
  'data-track-data-active'?: string;
}): ReactElement => {
  const chip = (
    <ChipFilter
      iconLeading={filter.iconLeading}
      isSelected={value}
      type="button"
      tabIndex={0}
      data-filter-id={filter.id}
      data-track-id={trackingId}
      data-track-action="update"
      data-track-data-filter-id={filter.id}
      data-track-data-selected={!value}
      data-track-data-active={trackedActive}
      onClick={onRemove}
     data-track-source-anchor="3d592ba632;toggle-filter-chip-filter">
      {filter.label}
    </ChipFilter>
  );

  return filter.description ? (
    <TooltipRoot>
      <Focusable>{chip}</Focusable>
      <Tooltip>{filter.description}</Tooltip>
    </TooltipRoot>
  ) : (
    chip
  );
};
